import { render, staticRenderFns } from "./UserPayslipView.vue?vue&type=template&id=b05f1cd6&"
import script from "./UserPayslipView.vue?vue&type=script&lang=js&"
export * from "./UserPayslipView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports